class CalendarUtils

  @extractDataFromDate: (date) ->
    d = dayjs(date)
    day = d.date()
    month = d.month() + 1
    weekday = d.format('dddd')
    monthName = d.format('MMMM')
    ordinality = @weekOrdinality date
    { day, weekday, month, monthName, ordinality }

  @weekOrdinality: (date) ->
    d = dayjs(date)
    nth = Math.ceil(d.date() / 7)
    isLastWeek = d.add(7, 'day').month() isnt d.month()
    isLastDay = d.add(1, 'day').month() isnt d.month()

    label = switch nth
      when 1 then '1st'
      when 2 then '2nd'
      when 3 then '3rd'
      when 4 then '4th'
      when 5 then '5th'

    { label, nth, isLastWeek, isLastDay }

export default CalendarUtils
